import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { catchError } from "rxjs/operators";
import { ConfigurationService, ForceBaseUrl } from "../configuration/configuration.service";
import { EndpointFactory } from "../endpoint-factory.service";
import { ITaskOrchestratorContext } from './../../pages/member/+components/task-orchestrator/task-orchestrator.models';

@Injectable({
    providedIn: "root",
})
export class TaskOrchestratorEndpoint extends EndpointFactory {


    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('member', force) + 'member';
    }


    constructor(
        http: HttpClient,
        configurations: ConfigurationService,
        injector: Injector
    ) {
        super(http, configurations, injector, "", configurations.webAppApiBaseUrl);
    }


    async getTaskOrchestratorContext(memberBase64: string, req?: any): Promise<ITaskOrchestratorContext> {
        const endpointUrl = `${this.getServiceBaseUrl('WEBAPI')}/${memberBase64}/tasks`;

        return await this.http.post<ITaskOrchestratorContext>(endpointUrl, req)
            .pipe(
                catchError(error => {
                    return this.handleError(error);
                })
            ).toPromise();
    }


}
